import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  animation: ${fadeIn} 0.3s ease-out forwards;
  padding-bottom: 20px;
`;

export const SidebarContainer = styled.div`
   display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 15px;
  margin: 10px;
  height:100%;
`;

export const CloseIcon = styled.img`
  position: absolute;
  cursor: pointer;
  width: 24px;
  height: 24px;
  top:20px;
  right:24px;
`;
export const BookingImg = styled.div`
  display: flex;
  jusitfy-content: center;
  align-items: center;
  width: 284px;
  height:262px;
  margin-bottom:20px;

`;

export const Title = styled.h1`
font-family: IBM Plex Sans;
font-weight: 700;
font-size: 24px;
line-height: 30px;
letter-spacing: 0%;
text-align: center;
margin-bottom:16px;
width:506px;
height:30px;
left:94px;
`;



export const MenuItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 398px;
`;

export const MenuButton = styled.label`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: ${(props) => (props.highlight ? '600' : '400')};
  font-size: var(--font-size-l);
  line-height: 24px;
  color: '#7200E0';
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background-color: transparent;
  padding: 8px 0;
  cursor: pointer;
  
  input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #7200E0; /* purple border by default */
  border-radius: 4.5px;
  cursor: pointer;
  display: inline-grid;
  place-content: center;
  background-color: white;
}

input[type="checkbox"]:checked {
  background-color: #7200E0;
}

input[type="checkbox"]:checked::after {
  content: "";
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

`;

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  width: 470px;
  color: #918B97;
  margin-top: 10px;
  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: #C9C6CC;
    opacity: 50%;
  }

  &::before {
    margin-right: 1.5px;
  }

  &::after {
    margin-left: 1.5px;
  }

  span {
    font-weight: 500;
    white-space: nowrap;
  }
`;

export const DividerText = styled.div`
color:#918B97;
font-weight: 400;
font-size:16px;
line-height:24px;
letter-spacing:0%;
text-align:center;
font-family:'IBM Plex Sans';
`;
export const SubmitButton = styled.button`
  background-color: #7200E0;
  color: white;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 16px;
  padding: 12px 32px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #5a00b3;
  }
  
  &:active {
    background-color: #4a0090;
  }
`;

export const Overlay = styled.div`
  width: calc(100vw - 80px);
  height: 100vh;
  margin-left: 80px;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  z-index: 1300;
  pointer-events: cursor;
`;

export const ModalWrapper = styled.div`
  width: 694px;
  max-width: 95%;
  height: ${(props) => (props.hasSubmit ? '692px' : '652px')};
  background-color: white;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  transition: height 0.25s ease;
  transform-origin: top;
`;



